{
  "planGen": {
    "preparingContext": "Préparation du contexte de génération du plan...",
    "generatingStructure": "Construction de la structure du plan...",
    "refiningExecSummary": "Affinage de la structure du plan (classification du résumé exécutif)...",
    "enrichmentComplete": "Enrichissement terminé — assemblage du plan...",
    "reviewingAlignment": "Vérification de l'alignement du plan…",
    "applyingTemplate": "Application du formatage du modèle…",
    "savingTemplate": "Enregistrement du modèle…",
    "finalizing": "Finalisation de la structure du plan...",
    "foundSections": "{{count}} sections trouvées",
    "enrichingDetails": "Enrichissement des détails ({{done}}/{{total}} appels terminés)",
    "enrichingStart": "Enrichissement de {{count}} sections sur {{agents}} appels parallèles…",
    "rateLimited": "Limite de débit — nouvelle tentative dans {{seconds}}s (essai {{attempt}}/{{max}})…",
    "enrichBatchFailed": "Le lot d'enrichissement {{batch}} sur {{total}} a échoué — poursuite.",
    "complete": "Génération du plan terminée",
    "connectionInterrupted": "Connexion interrompue — vérification de la progression...",
    "readingInputs": "Lecture de votre description de tâche et de votre modèle...",
    "extractingConstraints": "Extraction des exigences et des contraintes...",
    "retrievingKnowledge": "Récupération de la méthodologie et des connaissances métier...",
    "discoveringTools": "Identification des outils d'analyse disponibles...",
    "elapsedOfBudget": "{{elapsed}} s écoulées sur un budget de {{budget}} s"
  },
  "contentGen": {
    "preparingContext": "Préparation du contexte : {{title}}",
    "generatingContent": "Génération du contenu : {{title}}",
    "contentWrittenVerbatim": "Contenu de la section « {{title}} » rédigé (textuel)",
    "contentGenerated": "Contenu de la section « {{title}} » généré"
  },
  "sectionRegen": {
    "starting": "Démarrage de la régénération...",
    "refiringExecSummary": "Relance du résumé exécutif...",
    "retrievingContext": "Récupération du contexte...",
    "contextReady": "Contexte prêt",
    "generating": "Génération du contenu...",
    "finalizing": "Finalisation..."
  },
  "sectionGen": {
    "allGenerated": "Toutes les sections ont été générées. Lancement de la vérification de cohérence inter-sections.",
    "holisticWaiting": "L'auto-vérification globale attend {{count}} section(s) échouée(s). Réessayez pour continuer.",
    "normalizingInconsistencies": "Normalisation de {{count}} incohérences inter-sections.",
    "holisticComplete": "Auto-vérification globale terminée. Les sections sont prêtes pour la révision.",
    "generatingExecSummary": "Génération du résumé exécutif à partir du contenu auto-vérifié du rapport."
  }
}
